import Vue from 'vue'
import vSelect from "vue-select";

/** Animated Icons */
Vue.component('animated-error', require('Components/animatedIcons/ErrorAnimated').default);
Vue.component('animated-info', require('Components/animatedIcons/InfoAnimated').default);
Vue.component('animated-loading', require('Components/animatedIcons/LoadingAnimated').default);
Vue.component('animated-success', require('Components/animatedIcons/SuccessAnimated').default);
Vue.component('animated-warning', require('Components/animatedIcons/WarningAnimated').default);
Vue.component("v-select", vSelect);

/** Basket */
Vue.component('basket-item', require('Components/basket/BasketItem').default);
Vue.component('in-warranty-device-exists-modal', require('Components/basket/InWarrantyDeviceExistsModal').default);
Vue.component('side-basket', require('Components/basket/SideBasket').default);

/** Change Date **/
Vue.component('no-dates-available-modal', require('Components/date/NoDatesAvailableModal').default);

/** Complete */
Vue.component('imei-item', require('Components/complete/ImeiItem').default);

/** Contact */
Vue.component('email-modal', require('Components/contact/EmailModal').default);
Vue.component('message-modal', require('Components/contact/MessageModal').default);
Vue.component('phone-modal', require('Components/contact/PhoneModal').default);
Vue.component('contact-cancel-repair-guide', require('Components/contact/helpGuides/CancelRepair').default);
Vue.component('contact-change-address-guide', require('Components/contact/helpGuides/ChangeAddress').default);
Vue.component('contact-change-date-guide', require('Components/contact/helpGuides/ChangeDate').default);
Vue.component('contact-repair-cost-guide', require('Components/contact/helpGuides/RepairCost').default);
Vue.component('contact-track-technician-guide', require('Components/contact/helpGuides/TrackTechnician').default);

/** Device */
Vue.component('imei-modal', require('Components/device/ImeiModal').default);
Vue.component('make-unavailable-modal', require('Components/device/MakeUnavailableModal').default);
Vue.component('max-devices-in-basket-modal', require('Components/device/MaxDevicesInBasketModal').default);
Vue.component('out-of-warranty-modal', require('Components/device/OutOfWarrantyModal').default);
Vue.component('imei-error-modal', require('Components/device/ImeiErrorModal').default);

/** FAQs */
Vue.component('default-faqs-no-charge', require('Views/faqs/default/FaqsNoCallOutCharge').default);
Vue.component('default-faqs-with-charge', require('Views/faqs/default/FaqsCallOutCharge').default);
Vue.component('faq-category-menu', require('Components/faqs/CategoryMenu').default);
Vue.component('faq-contact-banner', require('Components/faqs/ContactBanner').default);
Vue.component('faq-item', require('Components/faqs/FaqItem').default);

/** Icons */
Vue.component('icon-ber', require('Components/icons/Ber').default);
Vue.component('icon-book-repair', require('Components/icons/BookRepair').default);
Vue.component('icon-box', require('Components/icons/Box').default);
Vue.component('icon-calendar', require('Components/icons/Calendar').default);
Vue.component('icon-calendar-check', require('Components/icons/CalendarCheck').default);
Vue.component('icon-calendar-cross', require('Components/icons/CalendarCross').default);
Vue.component('icon-call-us', require('Components/icons/CallUs').default);
Vue.component('icon-camera', require('Components/icons/Camera').default);
Vue.component('icon-checklist', require('Components/icons/Checklist').default);
Vue.component('icon-cogs', require('Components/icons/Cogs').default);
Vue.component('icon-device-back', require('Components/icons/DeviceBack').default);
Vue.component('icon-device-front', require('Components/icons/DeviceFront').default);
Vue.component('icon-device-invalid', require('Components/icons/DeviceInvalid').default);
Vue.component('icon-device-unknown', require('Components/icons/DeviceUnknown').default);
Vue.component('icon-email-us', require('Components/icons/EmailUs').default);
Vue.component('icon-home', require('Components/icons/Home').default);
Vue.component('icon-inbound-shipment', require('Components/icons/InboundShipment').default);
Vue.component('icon-in-house-repair', require('Components/icons/InHouseRepair').default);
Vue.component('icon-invoice', require('Components/icons/Invoice').default);
Vue.component('icon-live-chat', require('Components/icons/LiveChat').default);
Vue.component('icon-location', require('Components/icons/Location').default);
Vue.component('icon-map', require('Components/icons/Map').default);
Vue.component('icon-mobile', require('Components/icons/Mobile').default);
Vue.component('icon-outbound-shipment', require('Components/icons/OutboundShipment').default);
Vue.component('icon-payment-card', require('Components/icons/PaymentCard').default);
Vue.component('icon-printer', require('Components/icons/Printer').default);
Vue.component('icon-quote', require('Components/icons/Quote').default);
Vue.component('icon-quote-dollar', require('Components/icons/QuoteDollar').default);
Vue.component('icon-qr-code', require('Components/icons/QrCode').default);
Vue.component('icon-repair-kits-packing', require('Components/icons/RepairKitsPacking').default);
Vue.component('icon-repair-kits-picking', require('Components/icons/RepairKitsPicking').default);
Vue.component('icon-repair-kits-returns', require('Components/icons/RepairKitsReturns').default);
Vue.component('icon-refresh', require('Components/icons/Refresh').default);
Vue.component('icon-reload', require('Components/icons/Reload').default);
Vue.component('icon-scanner', require('Components/icons/Scanner').default);
Vue.component('icon-search-imei', require('Components/icons/SearchImei').default);
Vue.component('icon-serial-number', require('Components/icons/SerialNumber').default);
Vue.component('icon-shopping-cart', require('Components/icons/ShoppingCart').default);
Vue.component('icon-signal-none', require('Components/icons/SignalNone').default);
Vue.component('icon-spreadsheet', require('Components/icons/Spreadsheet').default);
Vue.component('icon-stock-pick', require('Components/icons/StockPick').default);
Vue.component('icon-switch-camera', require('Components/icons/SwitchCamera').default);
Vue.component('icon-tablet', require('Components/icons/Tablet').default);
Vue.component('icon-terms', require('Components/icons/Terms').default);
Vue.component('icon-ticket', require('Components/icons/Ticket').default);
Vue.component('icon-toolbox', require('Components/icons/Toolbox').default);
Vue.component('icon-tools', require('Components/icons/Tools').default);
Vue.component('icon-van', require('Components/icons/Van').default);
Vue.component('icon-van-clean', require('Components/icons/VanClean').default);
Vue.component('icon-warranty', require('Components/icons/Warranty').default);

/** Landing Pages */
Vue.component('landing-page-postcode-search', require('Components/landingPages/LandingPagePostcodeSearch').default);
Vue.component('landing-page-address-search', require('Components/landingPages/LandingPageAddressSearch').default);
Vue.component('pre-booking-completion-form', require('Components/landingPages/BookingCompletionForm').default);

Vue.component('ee-landing-page', require('Views/landingPages/ee/EeHome').default);
Vue.component('o2-landing-page', require('Views/landingPages/o2repair/O2RepairHome').default);
Vue.component('tesco-mobile-landing-page', require('Views/landingPages/tesco/TescoMobileRepairHome').default);
Vue.component('three-landing-page', require('Views/landingPages/three/ThreeRepairHome').default);
Vue.component('vodafone-landing-page', require('Views/landingPages/vodafone/VodafoneRepairHome').default);
Vue.component('wefix-landing-page', require('Views/landingPages/wefix/WeFixRepairHome').default);
Vue.component('wefix-au-landing-page', require('Views/landingPages/wefix/WeFixRepairAustraliaHome').default);
Vue.component('wefix-us-landing-page', require('Views/landingPages/wefix/WeFixRepairUSHome').default);
Vue.component('wefix-ca-landing-page', require('Views/landingPages/wefix/WeFixRepairCAHome').default);
Vue.component('likewize-repair-landing-page', require('Views/landingPages/likewize/LikewizeRepairHome').default);
Vue.component('likewize-confirm-landing-page', require('Views/landingPages/likewize/LikewizeConfirmHome').default);


/** Layout */
Vue.component('fixed-footer', require('Components/layout/NavigationFooter').default);
Vue.component('landing-page-navbar', require('Components/layout/LandingPageNavbar').default);
Vue.component('page-footer', require('Components/layout/PageFooter').default);
Vue.component('progress-bar', require('Components/layout/TheProgressBar').default);

/** Manage Booking */
Vue.component('booking-lookup-form', require('Components/manageBooking/BookingLookupForm').default);
Vue.component('cancel-booking-modal', require('Components/manageBooking/CancelBookingModal').default);
Vue.component('change-address-modal', require('Components/manageBooking/ChangeAddressModal').default);
Vue.component('change-date-modal', require('Components/manageBooking/ChangeDateModal').default);
Vue.component('imei-input-modal', require('Components/manageBooking/ImeiInputModal').default);
Vue.component('manage-booking-search-banner', require('Components/manageBooking/SearchBanner').default);

/** Misc */
Vue.component('empty-state', require('Components/misc/EmptyState').default);
Vue.component('loading-state', require('Components/misc/LoadingState').default);

/** Payments */
Vue.component('drop-in', require('Components/payment/braintree/DropIn').default);
Vue.component('drop-in-3d-secure', require('Components/payment/braintree/DropIn3DSecure').default);
Vue.component('klarna-payment-method', require('Components/payment/klarna/KlarnaPaymentMethod').default);
Vue.component('klarna-instalments-payment-method', require('Components/payment/klarna/KlarnaInstalmentsPaymentMethod').default);
Vue.component('payment-error-modal', require('Components/payment/PaymentErrorModal').default);

/** Form */
Vue.component('input-error', require('Components/form/InputError').default);

/** Custom Select Inputs */
Vue.component("v-select", vSelect);